"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "terracina": {
    "f24c4c6c": [{
      "hkey": "71090cd1",
      "slug": "litorale-circeo-porto-badino",
      "name": "Litorale Circeo-Porto Badino",
      "primary": true,
      "skipSearch": false
    }],
    "badino": [{
      "hkey": "71090cd1",
      "slug": "litorale-circeo-porto-badino",
      "name": "Litorale Circeo-Porto Badino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1130e4c6": [{
      "hkey": "7bf476e9",
      "slug": "terracina",
      "name": "Terracina",
      "primary": true,
      "skipSearch": false
    }],
    "frasso": [{
      "hkey": "7bf476e9",
      "slug": "terracina",
      "name": "Terracina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;